import React, { PureComponent } from 'react';
import { Row, Col } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { checkKey, hasAccess } from "../../Services/SecurityService";
import { check, findAllRequerimento, findAllByRequerimentoEstado_requerimento, 
          findAllByRequerimentoCidade_requerimento } from "../../Services/RequerimentoService";
import { findAllEstado } from "../../Services/EstadoService";
import { findAllCidade } from "../../Services/CidadeService";
import { findAllSubstanciaSubstanciaUso } from "../../Services/SubstanciaUsoService";
import { findAllSubstanciaByEnabled } from "../../Services/SubstanciaService";
import { findAllRequerimentoFaseByEnabled } from "../../Services/RequerimentoFaseService";
import { findAllRequerimentoEventoByEnabled } from "../../Services/RequerimentoEventoService";
import PropTypes from 'prop-types';
import MatTable from './MaterialTable/MatTable';
import CrudEdit from './edit';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudList extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };
  
  constructor(props) {
    super(props);
    this.setSelected = this.setSelected.bind(this)

    this.state = {
      hasAccess: false,
      selected: {},
      estados: [],
      requerimentoEstado: [],
      requerimentoCidade: [],
      fases: [],
      events: [],
      substancias: [],
      data: []
    };
    check();
  }

  loadRequerimento(selected){
    findAllRequerimento()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.setState({ data: data, selected });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadCidades(){
    findAllCidade()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.loadEstado(data);
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadEstado(cidadeList){
    findAllEstado()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      let cidades = [];
      let estados = [];
      if(data !== undefined && data.error === undefined){
        estados = data;
        for(let i = 0; i < estados.length; i++){
          cidades = [];
          for(let j = 0; j < cidadeList.length; j++){
            if(estados[i].id === cidadeList[j].estado.id){
              cidades.push(cidadeList[j]);
            }
          }
          estados[i].cidades = cidades;
        }
        this.setState({ estados: data });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadRequerimentoEstado(selected){
    findAllByRequerimentoEstado_requerimento(selected)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.loadRequerimentoCidade(selected, data.requerimentoEstadoList);
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadRequerimentoCidade(selected, requerimentoEstado){
    findAllByRequerimentoCidade_requerimento(selected)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        if(selected.colorRGB !== null && selected.colorRGB !== undefined && selected.colorRGB !== ''){
          let rgb = JSON.parse(selected.colorRGB);
          selected.colorRGB = rgb;
        }
        this.setState({ selected, requerimentoEstado, requerimentoCidade: data.requerimentoCidadeList });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadFase(){
    findAllRequerimentoFaseByEnabled(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.setState({ fases: data });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadEvento(){
    findAllRequerimentoEventoByEnabled(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.setState({ events: data });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadSubstancia(){
    findAllSubstanciaByEnabled(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.loadSubstanciaUso(data);
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadSubstanciaUso(substancias){
    findAllSubstanciaSubstanciaUso()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let substanciasUso = [];
        for(let i = 0; i < substancias.length; i++){
          substanciasUso = [];
          for(let j = 0; j < data.substanciaSubstanciaUsoList.length; j++){
            if(substancias[i].id === data.substanciaSubstanciaUsoList[j].substancia.id){
              substanciasUso.push(data.substanciaSubstanciaUsoList[j].substanciaUso);
            }
          }
          substancias[i].substanciasUso = substanciasUso;
        }
        this.setState({ substancias });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    if(checkKey("MENU_REQUIREMENT_VIEW")){
      this.loadRequerimento({});
      this.loadFase();
      this.loadEvento();
      this.loadSubstancia();
      this.loadCidades();
      this.setState({ hasAccess: true });
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  setSelected = (selected) => {
    this.loadRequerimentoEstado(selected);
  }

  updateTable = (selected, msg = null, success = true) => {
    this.loadRequerimento(selected);
    if(msg != null){
      if(success){
        this.show('success', msg);
      }else{
        this.show('danger', msg);
      }
    }
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;

    let view = '';
    let disabled = false;

    if(this.state.hasAccess){
      if(this.state.selected.id !== null && this.state.selected.id !== undefined){
        disabled = (this.state.selected.id === 0);
        view =  <CrudEdit 
                  selected = {this.state.selected} 
                  fases = {this.state.fases}
                  events = {this.state.events}
                  substancias = {this.state.substancias}
                  estados = {this.state.estados}
                  requerimentoEstado = {this.state.requerimentoEstado}
                  requerimentoCidade = {this.state.requerimentoCidade}
                  updateTable = {this.updateTable} />
      }else{
        view =  <MatTable 
                  title={t('forms.list')}
                  list={this.state.data}
                  setSelected = {this.setSelected}
                  updateTable = {this.updateTable} />
      }
    }

    return (
      <>
        <Row>
          <Col md={10}>
            <h3 className="page-title">{t('forms.requerimento_form.title')}</h3>
            <h3 className="page-subhead subhead">{t('forms.requerimento_form.description')}</h3>
          </Col>
        </Row>

        <Row>
          {view}
        </Row>
      </>
    );
  }
}

export default withTranslation('common')(CrudList);